import { NavLink } from "react-router-dom";
import { theme } from "../theme";
import { useApp } from "../AppContext";
import RankioLogo from "../components/RankioLogo";

export const SIDEBAR_WIDTH = 248;
// Odsazení sidebaru od okraje okna. Stejná hodnota drží i vodorovný rytmus
// obsahu, aby hlavička a karty pod ní seděly na jedné mřížce.
export const OKRAJ = 16;

const IconDashboard = (p) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
);
const IconProducts = (p) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>
);
const IconHistory = (p) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="m19 9-5 5-4-4-3 3"/></svg>
);
const IconSettings = (p) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.14.35.4.64.73.82.28.15.6.23.92.23H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></svg>
);

const NAV = [
  { to: "/",          label: "Přehled",   Icon: IconDashboard, end: true },
  { to: "/produkty",  label: "Produkty",  Icon: IconProducts },
  { to: "/historie",  label: "Historie",  Icon: IconHistory },
  { to: "/nastaveni", label: "Nastavení", Icon: IconSettings, id: "tour-settings" },
];

export default function Sidebar({ onNavigate }) {
  const { license, logout, shopMissing, nazvyPlanu } = useApp();

  const itemStyle = (isActive) => ({
    display: "flex", alignItems: "center", gap: 11,
    padding: "10px 13px", borderRadius: 11,
    color: isActive ? theme.blue : theme.inkSoft,
    background: isActive ? theme.blueSoft : "transparent",
    fontSize: 14.5, fontWeight: isActive ? 700 : 500,
    textDecoration: "none", transition: "all .15s",
  });

  return (
    <div style={{
      width: SIDEBAR_WIDTH, flexShrink: 0, height: "100%",
      background: theme.bg, border: `1px solid ${theme.line}`,
      borderRadius: theme.rCard, boxShadow: theme.shadowSm,
      display: "flex", flexDirection: "column", overflow: "hidden",
    }}>
      {/* logo */}
      <div style={{ padding: "22px 20px 18px" }}>
        <RankioLogo height={32} />
      </div>

      {/* menu */}
      <nav style={{ padding: "0 12px", display: "flex", flexDirection: "column", gap: 3, flex: 1, overflowY: "auto" }}>
        {NAV.map(({ to, label, Icon, end, id }) => (
          <NavLink key={to} to={to} end={end} id={id} onClick={onNavigate}
            style={({ isActive }) => itemStyle(isActive)}>
            {({ isActive }) => (
              <>
                <Icon style={{ flexShrink: 0, color: isActive ? theme.blue : theme.mut }} />
                {label}
                {/* nedokončené nastavení e-shopu — jen tečka, nic k odklikávání */}
                {to === "/nastaveni" && shopMissing && (
                  <span title="Chybí nastavený e-shop" style={{ marginLeft: "auto", width: 7, height: 7, borderRadius: "50%", background: theme.blue, flexShrink: 0 }} />
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* karta účtu — přišpendlená dole */}
      <div style={{ padding: 12, borderTop: `1px solid ${theme.line}` }}>
        <div style={{ background: theme.bgSoft, border: `1px solid ${theme.line}`, borderRadius: theme.rCard, padding: 13 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 10, flexShrink: 0,
              background: `linear-gradient(135deg, ${theme.blue}, ${theme.blueDark})`,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontWeight: 700, fontSize: 14,
            }}>
              {license?.email?.[0]?.toUpperCase() || "?"}
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ color: theme.ink, fontSize: 12.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={license?.email}>
                {license?.email || "—"}
              </p>
              <p style={{ color: theme.mut, fontSize: 11, fontVariantNumeric: theme.tnum }}>
                {license?.days_remaining != null ? `${license.days_remaining} dní zbývá` : "—"}
              </p>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{
              flex: 1, display: "inline-flex", alignItems: "center", gap: 6,
              background: theme.blueSoft, border: `1px solid ${theme.blueLine}`,
              borderRadius: 8, padding: "4px 9px",
              color: theme.blue, fontSize: 12, fontWeight: 700,
            }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: theme.blue, flexShrink: 0 }} />
              {nazvyPlanu[license?.plan] || license?.plan || "Trial"}
            </span>
            <button onClick={logout} title="Odhlásit se" style={{
              background: theme.bg, border: `1px solid ${theme.line}`, borderRadius: theme.rBtn,
              padding: "5px 8px", color: theme.inkSoft, cursor: "pointer",
              display: "flex", alignItems: "center", fontFamily: "inherit",
            }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
